import {
  Component,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';

@Component({
  selector: 'app-account-managment',
  templateUrl: './account-managment.component.html',
  styleUrls: ['./account-managment.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountManagmentComponent implements OnInit, OnDestroy, AfterViewInit {
  private location = inject(Location);
  private router = inject(Router);
  private _formBuilder = inject(FormBuilder);
  private behaviorService = inject(BehaviorService);
  private _mainAPiServiceService = inject(MainAPiServiceService);
  private cdf = inject(ChangeDetectorRef);

  clickbtn: string;
  isLoadingResults: boolean = false;
  isShowAccountView: boolean = false;
  stripeInfo: any = {};
  paymentMode: string = '';
  stripeUrl: string = '';
  tabindex: number = 0;
  sub: Subscription;
  private _unsubscribeAll$: Subject<void> = new Subject();

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingAccountMNG$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (result) {
          this.isLoadingResults = false;
          this.cdf.markForCheck();
        }
      },
    });
    this.nameFunction();
    this.loading_fun();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit() {
    this.getPaymentInfo();
  }

  /**
   * This function is used to basic information click
   */
  basicInfoClick(): void {
    this.location.replaceState('/system-setting/account-management/basicinfo');
    this.clickbtn = 'Contact Details';
    this.tabindex = 0;
    this.cdf.markForCheck();
  }

  /***
   * This function is used to click on the product
   */
  ProductClick(): void {
    this.location.replaceState('/system-setting/account-management/products');
    // this.location.replaceState("account-management/products");
    this.clickbtn = 'Products';
    this.tabindex = 1;
    this.cdf.markForCheck();
  }

  /**
   * This function is used to ReceiptClick function
   */
  ReceiptsClick(): void {
    this.location.replaceState('/system-setting/account-management/receipts');
    // this.location.replaceState("account-management/receipts");
    this.clickbtn = 'Receipts';
    this.tabindex = 2;
    this.cdf.markForCheck();
  }

  /**
   * This function is used to payment click
   */
  PaymentClick(): void {
    this.location.replaceState('/system-setting/account-management/payment');
    // this.location.replaceState("account-management/payment");
    this.clickbtn = 'Payment';
    this.tabindex = 3;
    this.cdf.markForCheck();
  }

  /**
   * This function is used to click on the user Activity.
   */
  UserActivityClick(): void {
    this.location.replaceState('/system-setting/account-management/useractivity');
    this.clickbtn = 'UserActivity';
    this.cdf.markForCheck();
  }

  /**
   * This function is used to get the loged on user
   */
  loggedOnUser(): void {
    this.location.replaceState('/system-setting/account-management/loggedon-user');
    this.clickbtn = 'LoggedOnUser';
    this.cdf.markForCheck();
  }

  /**
   * This functionn is used to Export the SILQ data
   */
  ExportToSLQ(): void {
    this.location.replaceState('/system-setting/account-management/export-to-SLQ');
    // this.location.replaceState("account-management/export-to-SLQ");
    this.clickbtn = 'ExportToSLQ';
    this.cdf.markForCheck();
  }

  /**
   * This function is used to get the name
   */
  nameFunction(): void {
    if (
      this.router.url == 'account-management/basicinfo' ||
      this.router.url == '/system-setting/account-management/basicinfo'
    ) {
      // this.clickbtn = "Basic Information";
      this.clickbtn = 'Contact Details';
      setTimeout(() => {
        this.tabindex = 0;
        this.cdf.markForCheck();
      }, 500);
    } else if (
      this.router.url == 'account-management/products' ||
      this.router.url == '/system-setting/account-management/products'
    ) {
      this.clickbtn = 'Products';
      setTimeout(() => {
        this.tabindex = 1;
        this.cdf.markForCheck();
      }, 500);
    } else if (
      this.router.url == 'account-management/receipts' ||
      this.router.url == '/system-setting/account-management/receipts'
    ) {
      this.clickbtn = 'Receipts';
      setTimeout(() => {
        this.tabindex = 2;
        this.cdf.markForCheck();
      }, 500);
    } else if (
      this.router.url == 'account-management/payment' ||
      this.router.url == '/system-setting/account-management/payment'
    ) {
      this.clickbtn = 'Payment';
      setTimeout(() => {
        this.tabindex = 3;
        this.cdf.markForCheck();
      }, 500);
    } else if (
      this.router.url == 'account-management/useractivity' ||
      this.router.url == '/system-setting/account-management/useractivity'
    ) {
      this.clickbtn = 'UserActivity';
    } else if (
      this.router.url == 'account-management/loggedon-user' ||
      this.router.url == '/system-setting/account-management/loggedon-user'
    ) {
      this.clickbtn = 'LoggedOnUser';
    } else if (
      this.router.url == 'account-management/export-to-SLQ' ||
      this.router.url == '/system-setting/account-management/export-to-SLQ'
    ) {
      this.clickbtn = 'ExportToSLQ';
    }
    this.cdf.markForCheck();
  }

  /**
   * This function is used to load the function data
   */
  loading_fun(): void {
    this.behaviorService.loadingAccountMNG(null);
    setTimeout(() => {
      this.isLoadingResults = true;
      this.cdf.markForCheck();
    }, 10);
  }

  /**
   * This function is used to get the payment Information
   */
  getPaymentInfo(): void {
    this.sub = this._mainAPiServiceService
      .getSetData({}, 'HOGetPaymentDetailURL')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          this.isLoadingResults = false;
          if (response.CODE == 200 && response.STATUS == 'success') {
            let respData: any = response.DATA;
            this.paymentMode = respData.MODE;
            if (respData.MODE == 'STRIPE') {
              this.isShowAccountView = false;
              this.stripeUrl = respData.RETURNURL;
              // for stripe
              if (respData.NEWTABREQUIRED == '1' || respData.NEWTABREQUIRED == 1) {
                window.open(respData.RETURNURL, '_blank', 'noopener,noreferrer');
              } else {
                window.open(respData.RETURNURL);
              }
            } else if (respData.MODE == 'SIGNUP') {
              this.isShowAccountView = false;
              this.stripeInfo = respData;
              this.isLoadingResults = false;
              if (!this.isShowAccountView) {
                const stripeView: string = `
                                    <stripe-pricing-table
                                    pricing-table-id="${this.stripeInfo.PRICINGTABLEID}"
                                    publishable-key="${this.stripeInfo.PUBLISHABLEKEY}"
                                    client-reference-id="${this.stripeInfo.CLIENTREFERENCEID}"
                                    customer-metadata='{
                                        "SILQCustomerGuid":"${this.stripeInfo.CLIENTREFERENCEID}",
                                        "SILQRegistrationName":"${this.stripeInfo.REGISTRATIONNAME}"
                                    }'>
                                    </stripe-pricing-table>
                                `;

                document.getElementById('stripePurchasePlan')!.innerHTML = stripeView;
              }
            } else if (respData.MODE == 'EZIDEBIT') {
              this.isShowAccountView = true;
            }
          }
          this.cdf.markForCheck();
        },
        error: (error: any) => {
          this.isLoadingResults = false;
          this.cdf.markForCheck();
        },
      });
  }

  /**
   * This function is used to open the stripe url
   */
  openStripeUrl(): void {
    window.open(this.stripeUrl, '_blank', 'noopener,noreferrer');
  }

  /**
   * This function is used to select the account data.
   * @param event -event data
   */
  onSelectAccount(event: any): void {
    this.loading_fun();
    if (event.index == 0) {
      this.basicInfoClick();
    } else if (event.index == 1) {
      this.ProductClick();
    } else if (event.index == 2) {
      this.ReceiptsClick();
    } else if (event.index == 3) {
      this.PaymentClick();
    }
    this.cdf.markForCheck();
  }
}
